import React from 'react';
import { Collapse } from 'antd';
import { useBundle } from '@amzn/react-arb-tools';
import { safeGetMessage } from '@xbcb/ui-utils';
import type { ReasoningStep } from './types';
import { ReasoningContent } from './styles';

const { Panel } = Collapse;

interface ReasoningSectionProps {
  reasoningTrace: ReasoningStep[];
}

export const ReasoningSection: React.FC<ReasoningSectionProps> = ({
  reasoningTrace,
}) => {
  const [bundle] = useBundle('components.HtsClassification');

  if (!reasoningTrace.length) return null;

  return (
    <Collapse ghost>
      <Panel
        key="reasoning"
        header={safeGetMessage(bundle, 'hts_classification_reasoning_label')}
      >
        <ReasoningContent>
          {[...reasoningTrace]
            .sort((a, b) => a.step - b.step)
            .map((s) => s.content)
            .join(' ')}
        </ReasoningContent>
      </Panel>
    </Collapse>
  );
};
